import { render, staticRenderFns } from "./YouthDisclosureComponent.vue?vue&type=template&id=2ee3a692&scoped=true"
import script from "./YouthDisclosureComponent.vue?vue&type=script&lang=js"
export * from "./YouthDisclosureComponent.vue?vue&type=script&lang=js"
import style0 from "./YouthDisclosureComponent.vue?vue&type=style&index=0&id=2ee3a692&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee3a692",
  null
  
)

export default component.exports